import { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from '@/components/ui/command';

interface Props {
  id: string;
  label: string;
  selectedId?: string | null;
  selectedLabel: string;
  options: Array<{ id: string; label: string }>;
  disabled?: boolean;
  onSelect: (id: string | null) => void;
}

export function ReferrerSearchSelect({ id, label, selectedId, selectedLabel, options, disabled, onSelect }: Props) {
  const [open, setOpen] = useState(false);
  const pick = (value: string | null) => { onSelect(value); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button id={id} type="button" variant="outline" role="combobox" aria-expanded={open}
          aria-label={label} disabled={disabled} className="w-full justify-between font-normal">
          <span className="truncate">{selectedLabel || `Select ${label.toLowerCase()}`}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[var(--radix-popover-trigger-width)] min-w-[260px] p-0">
        <Command>
          <CommandInput placeholder={`Search ${label.toLowerCase()}…`} />
          <CommandList className="max-h-64">
            <CommandEmpty>No matching directory entries.</CommandEmpty>
            <CommandItem value="No referring selection" onSelect={() => pick(null)}>None</CommandItem>
            {options.map((option) => (
              <CommandItem key={option.id} value={`${option.label} ${option.id}`} onSelect={() => pick(option.id)}>
                <Check className={`mr-2 h-4 w-4 shrink-0 ${selectedId === option.id ? 'opacity-100' : 'opacity-0'}`} />
                <span>{option.label}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
